import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

import { Link } from 'modules/UI';

export const HomeLink = styled(Link)`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
`;

export const Logo = styled.img`
  margin-right: ${tokens.space.smallest};
  width: 167px;
`;
